import styled from "styled-components"

export const NavModuleStyles = styled.nav`
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    padding: 22px var(--borderSpacing);

    @media (min-width: 1024px) {
      padding: 34px var(--borderSpacing);
    }
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  .menu {
    background-color: var(--color-ink-pure);
    width: var(--menuWidth);
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 99;
    padding: 0 var(--borderSpacing);
    display: flex;
    align-items: center;

    /* soft amber stage-glow in the corner */
    &::after {
      content: "";
      position: absolute;
      bottom: -25%;
      right: -10%;
      width: 60vw;
      height: 60vw;
      background: radial-gradient(
        circle,
        var(--color-glow),
        rgba(0, 0, 0, 0) 60%
      );
      pointer-events: none;
    }
  }
`

export const NavTopLevel = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 1320px;
  margin-inline: auto;
  position: relative;
  z-index: 1;

  .menu__eyebrow {
    font-family: var(--font-sans);
    font-size: var(--text-kicker);
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--color-gold-500);
    margin: 0 0 calc(var(--gap) / 1.5) 0;
  }

  > li {
    border-top: 1px solid var(--color-line);

    &:last-child {
      border-bottom: 1px solid var(--color-line);
    }

    a {
      display: flex;
      align-items: baseline;
      gap: clamp(0.85rem, 2.2vw, 2rem);
      padding: clamp(0.6rem, 1.8vw, 1.5rem) 0;
      text-decoration: none;
      color: var(--color-paper);
      font-family: var(--font-display);
      font-weight: 600;
      font-size: clamp(2.4rem, 9vw, 5.5rem);
      line-height: 1;
      letter-spacing: -0.03em;
      text-transform: capitalize;
      transition: color 0.4s var(--ease-power), padding-left 0.4s var(--ease-power);

      .index {
        font-family: var(--font-sans);
        font-size: 0.85rem;
        font-weight: 600;
        letter-spacing: 0.1em;
        color: var(--color-gold-500);
        transform: translateY(-0.55em);
      }

      .dot {
        color: var(--color-gold-500);
      }

      &:hover,
      &:focus,
      &.menu__item--active {
        color: var(--color-gold-500);
        padding-left: 0.75rem;
      }
    }
  }
`

export const MenuToggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px 0;
  color: var(--color-paper);
  font-family: var(--font-sans);
  font-size: 0.95rem;
  font-weight: 600;
  text-shadow: var(--textShadow);
  transition: color 0.3s var(--ease-power);

  .bars {
    display: inline-flex;
    flex-direction: column;
    gap: 4px;

    span {
      display: block;
      width: 22px;
      height: 2px;
      background: var(--color-gold-500);
      transition: transform 0.4s var(--ease-power), width 0.4s;
    }
  }

  &:hover,
  &:focus {
    color: var(--color-gold-500);
  }

  &.is-open .bars span:nth-child(1) {
    transform: translateY(3px) rotate(45deg);
  }
  &.is-open .bars span:nth-child(2) {
    transform: translateY(-3px) rotate(-45deg);
  }
`

export const LogoStyles = styled.div`
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 19px;
  letter-spacing: -0.01em;
  line-height: 1;
  text-shadow: var(--textShadow);

  a {
    color: var(--color-paper);
    text-decoration: none;
    transition: color 0.3s var(--ease-power);
  }

  span {
    color: var(--color-gold-500);
  }

  &:hover,
  &:focus {
    a {
      color: var(--color-gold-500);
    }
  }

  @media (min-width: 1024px) {
    font-size: 23px;
  }
`
